import { dispatchCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["image"]

  connect() {
    dispatchCustomEvent("image-cropper:open", this.element, { controller: this })
  }

  // When the user clicks 'Crop', this handler will:
  //   get the Croppie result
  //   store the blob version in a hidden field to pass to server on form submit
  //   change the image preview to the new image
  //   close the cropping area
  crop(event) {
    event && event.preventDefault()
    this.imageTarget.croppie
    const controller = this
    App.ImageCropper.getResultFrom(this.imageTarget).then(function(blob) {
      const file = new File([blob], controller.fileName);
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      dataTransfer.initiatingEntity = controller.initiatingEntity
      dispatchCustomEvent("image-cropper:crop-complete", controller.element, { dataTransfer })
      controller.closeCropModal();
    });
  }

  // Function to close the cropping area
  closeCropModal() {
    App.ImageCropper.destroyCropper(this.imageTarget)
    App.Modal.close();
  }

  // On canceling crop:
  //   Change the value of the file select to null
  //   Clost the cropping area
  cancel(event) {
    event && event.preventDefault()
    dispatchCustomEvent("image-cropper:cancel", this.element, { initiatingEntity: this.initiatingEntity })
    this.closeCropModal()
  }

  set dataTransfer(dataTransfer) {
    this.fileReader = new FileReader();
    this.initiatingEntity = dataTransfer.initiatingEntity
    this.fileName = dataTransfer.files[0].name
    const imageTarget = this.imageTarget

    // after the file is loaded, open up the cropping area
    this.fileReader.addEventListener("load", function(event) {
      imageTarget.src = this.result
      App.ImageCropper.getCropperFor(imageTarget, {
        viewport: {
          width: 365,
          height: 365
        },
        boundary: {
          width: 420,
          height: 420
        }
      })
    });

    // open the selected file
    this.fileReader.readAsDataURL(dataTransfer.files[0]);

  }

  get fileName() {
    return this.data.get("file-name")
  }

  set fileName(name) {
    this.data.set("file-name", name)
  }
}



// WEBPACK FOOTER //
// ./app/components/images/assets/javascript/images-image-cropper-controller.js